export const collections = [
  {
    id: "c1",
    title: "豆瓣高分电影",
    subtitle: "口碑与热度兼具的年度之选",
    cover:
      "https://readdy.ai/api/search-image?query=A%20stack%20of%20premium%20film%20reels%20and%20a%20golden%20award%20trophy%20on%20a%20dark%20cinematic%20background%2C%20luxury%20editorial%20photography%2C%20warm%20amber%20lighting%2C%20high%20detail%2C%20clean%20minimal%20composition&width=640&height=400&seq=collection-01&orientation=landscape",
    query: "高分",
  },
  {
    id: "c2",
    title: "经典必看电视剧",
    subtitle: "值得二刷的国剧经典",
    cover:
      "https://readdy.ai/api/search-image?query=An%20elegant%20collection%20of%20classic%20television%20screens%20glowing%20in%20a%20dark%20cozy%20room%2C%20cinematic%20editorial%20photography%2C%20warm%20amber%20lighting%2C%20high%20detail%2C%20clean%20minimal%20composition&width=640&height=400&seq=collection-02&orientation=landscape",
    query: "经典",
  },
  {
    id: "c3",
    title: "科幻宇宙精选",
    subtitle: "穿越星海，触摸未来",
    cover:
      "https://readdy.ai/api/search-image?query=A%20futuristic%20galaxy%20with%20glowing%20nebula%20and%20a%20silhouette%20of%20a%20spaceship%2C%20science%20fiction%20editorial%20photography%2C%20cyan%20and%20amber%20color%20grading%2C%20high%20detail%2C%20clean%20minimal%20composition&width=640&height=400&seq=collection-03&orientation=landscape",
    query: "科幻",
  },
  {
    id: "c4",
    title: "温暖治愈系",
    subtitle: "慢下来，感受生活的光",
    cover:
      "https://readdy.ai/api/search-image?query=A%20cozy%20sunlit%20room%20with%20soft%20blanket%20and%20a%20cup%20of%20tea%20by%20the%20window%2C%20lifestyle%20editorial%20photography%2C%20warm%20amber%20lighting%2C%20high%20detail%2C%20clean%20minimal%20composition&width=640&height=400&seq=collection-04&orientation=landscape",
    query: "治愈",
  },
  {
    id: "c5",
    title: "高分悬疑烧脑",
    subtitle: "一环扣一环的反转盛宴",
    cover:
      "https://readdy.ai/api/search-image?query=A%20mysterious%20detective%20desk%20with%20magnifying%20glass%2C%20old%20photographs%20and%20dim%20lighting%2C%20cinematic%20editorial%20photography%2C%20cold%20teal%20and%20amber%20color%20grading%2C%20high%20detail%2C%20clean%20minimal%20composition&width=640&height=400&seq=collection-05&orientation=landscape",
    query: "悬疑",
  },
  {
    id: "c6",
    title: "国风古装大剧",
    subtitle: "一梦千年，风起长安",
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20architecture%20with%20red%20lanterns%20and%20silk%20banners%20at%20dusk%2C%20cinematic%20editorial%20photography%2C%20crimson%20and%20gold%20color%20grading%2C%20high%20detail%2C%20clean%20minimal%20composition&width=640&height=400&seq=collection-06&orientation=landscape",
    query: "古装",
  },
];